/**
 * グラフ本体と設定スロットが共有する store 読み取り＋棒グラフ用 grid 解決。
 */

import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useKeisukeDashboardStore } from '../../../../stores/systems/keisuke/dashboardStore';
import { resolveDashboardBarChartGrid } from './keisukeDashboardChartUtils';

export function useKeisukeDashboardChartSource() {
  const { gridData, gridHeaders, analysisOptions, resultCache } = useKeisukeDashboardStore(
    useShallow((s) => ({
      gridData: s.gridData,
      gridHeaders: s.gridHeaders,
      analysisOptions: s.analysisOptions,
      resultCache: s.resultCache,
    }))
  );

  const chartType = analysisOptions.type ?? 't-test';
  const significancePairs = resultCache?.significancePairs ?? [];

  const { gridData: barChartGridData, groupCol, valueCol } = useMemo(
    () =>
      resolveDashboardBarChartGrid(gridData, gridHeaders, {
        type: analysisOptions.type,
        testType: analysisOptions.testType,
        anovaType: analysisOptions.anovaType,
        mapping: analysisOptions.mapping,
      }),
    [
      gridData,
      gridHeaders,
      analysisOptions.type,
      analysisOptions.testType,
      analysisOptions.anovaType,
      analysisOptions.mapping,
    ]
  );

  return {
    analysisOptions,
    resultCache,
    chartType,
    significancePairs,
    barChartGridData,
    groupCol,
    valueCol,
    valueAxisLabel: analysisOptions.mapping?.valueAxisLabel,
  };
}
